import { Text, View } from 'react-native'
import { styled } from '~/utils'

export const Header = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.sizingMicro,
    },
  }
})

export const Title = styled(Text, theme => {
  return {
    base: {
      flex: 1,
      fontSize: theme.fontSizeThreeandhalfpulse,
      fontFamily: theme.fontFamily.bold,
      color: theme.colorTextNeutralDefault,
    },
  }
})
